/**
 * Determines if a given step has missing fields
 *
 * @returns boolean
 */
import { WEDDINGS_GIFT_STEPS } from './constants';

export const hasMissingFields = (step, values) => {
  switch (step) {
    case WEDDINGS_GIFT_STEPS.DETAILS:
      return (
        !values.first_name ||
        !values.last_name ||
        !values.relationship ||
        !values.phone_number ||
        !values.groom_name ||
        !values.bride_name
      );
    case WEDDINGS_GIFT_STEPS.PIN_VERIFY:
      return !values.code || values.code?.length !== 4;
    case WEDDINGS_GIFT_STEPS.SEND_GIFT_NOW:
      return (
        !values.couples_name ||
        !values.couples_phone_number ||
        !values.couple_email_address
      );
    default:
      return false;
  }
};
